import { Tag } from 'antd';
import styled from 'styled-components';

export const TemplateBadgeStyled = styled(Tag)`
	display: inline-block;
	margin: 0;
	border-style: none;
	border-radius: 24px;
	background: linear-gradient(106deg, #7beaad 4.99%, #16bbd7 100%);
	color: #fff;
	font-size: 12px;
`;
